angular.module('zc').component('zcDashboardCampaignCountChart', {
  templateUrl: '/templates/projects.dashboard/campaign_count_chart.html',
  bindings: {
    project: '<',
    chart: '<',
  },
  controller: zcDashboardCampaignCountChartController
});

zcDashboardCampaignCountChartController.$inject = [
  '$scope',
  '$filter',
  'ChartV2',
  'campaignStatusTexts',
  'pieChartV2Config',
];

function zcDashboardCampaignCountChartController($scope, $filter, ChartV2, campaignStatusTexts, pieChartV2Config) {
  const vm = this;

  $scope.$watch('$ctrl.project', project => {
    if(!project || !project.thisMonthStat) return;
    setChartConfig();
  });

  function setChartConfig() {
    const totalCampaignCount = vm.project.campaigns.length;
    const campaignCountByStatus = _.countBy(vm.project.campaigns, campaign => $filter('currentStatus')(campaign));
    const campaigns = _.map(campaignCountByStatus, (count, status) => [campaignStatusTexts[status], count]);
    const chart = new ChartV2(pieChartV2Config);

    chart.addSeries({
      type: 'pie',
      name: $filter('translate')('projectsDashboard.campaignCountChart.campaignCount'),
      innerSize: '50%',
      data: campaigns,
    });

    vm.chartConfig = chart.getConfig();
    _.merge(vm.chartConfig.options, {
      chart: {
        width: vm.chart.chart_width,
        height: vm.chart.chart_height,
      },
      title: {
        align: 'center',
        layout: 'vertical',
        verticalAlign: 'middle',
        y: -30,
        text: `
          <span class="u-color-babyblue o-type-xl">
            ${campaignCountByStatus.active || 0}
          </span>
          <span class="u-color-babyblue o-type-l">
            / ${totalCampaignCount}
          </span>
          <p>${$filter('translate')('projectsDashboard.campaignCountChart.duringDelivery')}</p>`,
        useHTML: true,
      },
      legend: {
        enabled: true,
      },
      plotOptions: {
        pie: {
          dataLabels: {
            enabled: false,
          },
          showInLegend: true,
        },
      },
    });

  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.dashboard/campaign_count_chart.controller.js